import { Component, OnInit } from '@angular/core';
import { CompanyInfoStateService } from '../../services/company-info-state.service';
import { CompanyWorkingHours } from '../../models/company-working-hours';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-company-working-hours',
  templateUrl: './company-working-hours.component.html',
  styleUrls: ['./company-working-hours.component.css']
})
export class CompanyWorkingHoursComponent implements OnInit {

  constructor(
    private companyInfoStateService: CompanyInfoStateService,
  ) { }

  ngOnInit() {
    this.companyInfoStateService.initialize().subscribe();
    this.companyInfoStateService.initializeTodayWorkingHours().subscribe();
  }

  get todayWorkingHours(): CompanyWorkingHours {
    return this.companyInfoStateService.todayWorkingHours;
  }

  get currentLocalTimeFloat(): number {
    return environment.globalSettings.getCurrentLocalTimeFloat();
  }

  get companyTagline(): string {
    if (this.companyInfoStateService.companyInfo) {
      return this.companyInfoStateService.companyInfo.tagline;
    }
    return '';
  }
}
